(() => {

  const modal = document.querySelector('.digi-packs-modal');

  if (!modal) return;

  const overlay = modal.querySelector('.digi-packs-modal__overlay');

  const closeBtn = modal.querySelector('[data-close-modal]');

  const subtotalEl = modal.querySelector('[data-subtotal]');

  const discountEl =
    modal.querySelector('[data-discount]');

  const totalEl =
    modal.querySelector('[data-total]');

  const submitBtn =
    modal.querySelector('[data-submit-pack]');

  const selectedProductsEl =
    modal.querySelector('[data-selected-products]');

  const progressFill =
    modal.querySelector('[data-progress-fill]');

  const progressText =
    modal.querySelector('[data-progress-text]');

  const state = {};

  let activeBundleStep = '';
  let activeBundleDiscount = 0;
  let activeGifts = [];

  const minimumItems =
    Number(
      modal.dataset.minimumItems
    ) || 2;

  const maximumItems =
    Number(
      modal.dataset.maximumItems
    ) || 5;

  const progressStepElements =
    [...modal.querySelectorAll('[data-progress-step]')];

  /* STEP POSITIONS */

  const progressSteps =
    progressStepElements
      .map(stepEl => ({
        el: stepEl,

        id:
          stepEl.dataset.stepId || '',

        requiredItems:
          Number(stepEl.dataset.requiredItems || 0),

        discount:
          Number(stepEl.dataset.stepDiscount || 0),

        enableGift:
          stepEl.dataset.enableGift === 'true',

        giftVariantId:
          stepEl.dataset.giftVariantId || '',

        giftTitle:
          stepEl.dataset.giftTitle || '',

        giftImage:
          stepEl.dataset.giftImage || ''
      }))
      .filter(step =>
        step.requiredItems > 0 &&
        step.discount >= 0
      )
      .sort((a, b) =>
        a.requiredItems - b.requiredItems
      );

  const maxProgressItems =
    progressSteps[progressSteps.length - 1]
      ?.requiredItems || maximumItems;

  /* STEP POSITIONS */

  progressSteps.forEach(step => {

    const position =
      Math.min(
        (step.requiredItems / maxProgressItems) * 100,
        100
      );

    step.el.style.left = `${position}%`;

  });

  // ==============================
  // CART DRAWER (igual Bold Box)
  // ==============================
  function openCartDrawer(){

    const btn =
      document.querySelector('[data-open-cart-sidebar]') ||
      document.querySelector('[data-cart-toggle]');

    if (btn){
      btn.click();
      return;
    }

    document.body.classList.add(
      'open-cart-sidebar'
    );

  }

  /* OPEN / CLOSE */

  function openModal(event) {

    resetModalSelection();

    modal.hidden = false;

    document.body.style.overflow =
      'hidden';

    const presets =
      event?.detail?.presets || [];

    if (presets.length) {

      applyPresetProducts(presets);

    }

  }

  function resetModalSelection() {

    Object.keys(state).forEach(key => {
      delete state[key];
    });

    modal
      .querySelectorAll('[data-product-card]')
      .forEach(card => {

        card.classList.remove('is-selected');

        const qty =
          card.querySelector('[data-qty]');

        if (qty) {
          qty.textContent = 1;
        }

      });

    activeBundleStep = '';
    activeBundleDiscount = 0;
    activeGifts = [];

    updateSummary();

  }

  function applyPresetProducts(presets) {

    presets.forEach(preset => {

      const variantId =
        String(preset.variantId);

      const qty =
        Number(preset.qty || 1);

      if (!variantId || qty <= 0) return;

      const card =
        modal.querySelector(
          `[data-product-card][data-variant-id="${variantId}"]`
        );

      if (!card) return;

      const price =
        Number(card.dataset.price);

      state[variantId] = {
        qty,
        price
      };

      card.classList.add('is-selected');

      const qtyEl =
        card.querySelector('[data-qty]');

      if (qtyEl) {
        qtyEl.textContent = qty;
      }

    });

    updateSummary();

  }

  function closeModal() {

    resetModalSelection();

    modal.hidden = true;

    document.body.style.overflow = '';

  }

  document.addEventListener(
    'digi:open-pack-modal',
    openModal
  );

  overlay.addEventListener('click', closeModal);

  closeBtn.addEventListener('click', closeModal);

  /* TABS */

  const tabs =
    modal.querySelectorAll('[data-tab-button]');

  const panels =
    modal.querySelectorAll('[data-tab-panel]');

  tabs.forEach(tab => {

    tab.addEventListener('click', () => {

      const id = tab.dataset.tab;

      tabs.forEach(t =>
        t.classList.remove('is-active')
      );

      panels.forEach(panel =>
        panel.classList.add('hidden')
      );

      tab.classList.add('is-active');

      modal
        .querySelector(`[data-tab-panel="${id}"]`)
        ?.classList.remove('hidden');

    });

  });

  /* CREATE BUNDLE */

  function createBundleId() {
    return `digi-pack-${Date.now()}`;
  }

  function buildCartItems() {
    const bundleId =
      createBundleId();

    const bundleKey =
      'bold-master-pack';

    const items = [];

    Object.entries(state).forEach(([variantId, item]) => {

      items.push({
        id: Number(variantId),
        quantity: item.qty,
          properties: {
            _bundleId: bundleId,
            _bundleKey: bundleKey,
            _bundleRole: 'child',
            _bundleStep: activeBundleStep,
            _bundleDiscount: String(activeBundleDiscount)
          }
      });

    });

    console.log('ACTIVE GIFTS:', activeGifts);
    activeGifts.forEach(gift => {

      items.push({
        id: Number(gift.giftVariantId),
        quantity: 1,
          properties: {
            _bundleId: bundleId,
            _bundleKey: bundleKey,
            _bundleRole: 'gift',
            _bundleStep: activeBundleStep,
            _bundleDiscount: String(activeBundleDiscount),
            _giftTitle: gift.giftTitle
          }
      });

    });

    return items;
  }

  /* SUBTOTAL */

  function updateSummary() {

    let subtotal = 0;
    let totalItems = 0;

    let discountPercent = 0;
    let progressPercent = 0;

    let missingItems = 0;
    let nextReward = '';

    Object.values(state).forEach(item => {

      subtotal += item.price * item.qty;

      totalItems += item.qty;

    });

    /* DESCONTOS */

    let activeStep = null;

    progressSteps.forEach(step => {

      if (totalItems >= step.requiredItems) {
        activeStep = step;
      }

    });

    if (activeStep) {

      discountPercent =
        activeStep.discount;

      activeBundleStep =
        activeStep.id;

      activeBundleDiscount =
        activeStep.discount;

    } else {

      activeBundleStep = '';
      activeBundleDiscount = 0;

    }

    activeGifts =
      progressSteps.filter(step =>
        step.enableGift &&
        step.giftVariantId &&
        totalItems >= step.requiredItems
      );

    /* NEXT STEP */

    const nextStep =
      progressSteps.find(
        step =>
          totalItems < step.requiredItems
      );

    if (nextStep) {

      missingItems =
        nextStep.requiredItems - totalItems;

      nextReward =
        nextStep.discount + '% OFF';

    } else {

      missingItems = 0;

      nextReward = 'MÁXIMO LIBERADO';

    }

    /* PROGRESSO VISUAL */

    progressPercent =
      Math.min(
        (totalItems / maxProgressItems) * 100,
        100
      );

    const discountValue =
      subtotal * (discountPercent / 100);

    const total =
      subtotal - discountValue;

    /* RENDER */

    subtotalEl.textContent =
      formatMoney(subtotal);

    discountEl.textContent =
      `- ${formatMoney(discountValue)}`;

    totalEl.textContent =
      formatMoney(total);

    /* CTA */

    const canSubmit =
      totalItems >= minimumItems;

    submitBtn.disabled = !canSubmit;

    submitBtn.classList.toggle(
      'is-disabled',
      !canSubmit
    );

    /* PROGRESS */

    progressFill.style.width =
      `${progressPercent}%`;

    if (missingItems > 0) {

      const itemLabel =
        missingItems === 1
          ? 'ITEM'
          : 'ITENS';

      const missingText =
        missingItems === 1
          ? 'Falta'
          : 'Faltam';

      progressText.innerHTML = `
        ${missingText}
        <span class="digi-progress-highlight">
          ${missingItems} ${itemLabel}
        </span>
        para liberar
        <span class="digi-progress-highlight">
          ${nextReward}
        </span>.
      `;

    } else {

      progressText.innerHTML = `
        <span class="digi-progress-highlight">
          UHUL!
        </span>
        Desconto máximo liberado!
      `;

    }

    progressSteps.forEach(step => {

      step.el.classList.toggle(
        'is-active',
        totalItems >= step.requiredItems
      );

    });

    /* THUMBS */

    renderSelectedProducts();

  }

  /* THUMBS + QTY */

  function renderSelectedProducts() {

    selectedProductsEl.innerHTML = '';

    Object.entries(state).forEach(([variantId, item]) => {

      const card = modal.querySelector(
        `[data-product-card][data-variant-id="${variantId}"]`
      );

      if (!card) return;

      const image =
        card.querySelector('img')?.src;

      const thumb = document.createElement('div');

      thumb.className =
        'digi-packs-modal__selected-thumb';

      thumb.innerHTML = `
        <img src="${image}" alt="">

        <span class="digi-packs-modal__selected-qty">
          ${item.qty}
        </span>
      `;

      selectedProductsEl.appendChild(thumb);

    });

    activeGifts.forEach(gift => {

      if (!gift.giftImage) return;

      const thumb = document.createElement('div');

      thumb.className =
        'digi-packs-modal__selected-thumb is-gift';

      thumb.innerHTML = `
        <img src="${gift.giftImage}" alt="${gift.giftTitle}">

        <span class="digi-packs-modal__selected-qty is-gift">
          🎁
        </span>
      `;

      selectedProductsEl.appendChild(thumb);

    });

  }

  /* PRODUCTS */

  modal.addEventListener('click', (event) => {

    const plus =
      event.target.closest('[data-plus]');

    const minus =
      event.target.closest('[data-minus]');

    const card =
      event.target.closest('[data-product-card]');

    if (
      card &&
      card.dataset.available === 'false'
    ) {
      return;
    }

    /* CLICK CARD */

    if (
      card &&
      !plus &&
      !minus
    ) {

      const variantId =
        card.dataset.variantId;

      const price =
        Number(card.dataset.price);

      /* CREATE */

      if (!state[variantId]) {

        state[variantId] = {
          qty: 1,
          price
        };

        card.classList.add('is-selected');

      } else {

        /* INCREMENT */

        state[variantId].qty++;

      }

      card.querySelector('[data-qty]')
        .textContent =
        state[variantId].qty;

      updateSummary();

    }

    /* PLUS */

    if (plus) {

      const card =
        plus.closest('[data-product-card]');

      const variantId =
        card.dataset.variantId;

      state[variantId].qty++;

      card.querySelector('[data-qty]')
        .textContent =
        state[variantId].qty;

      updateSummary();

    }

    /* MINUS */

    if (minus) {

      const card =
        minus.closest('[data-product-card]');

      const variantId =
        card.dataset.variantId;

      state[variantId].qty--;

      if (state[variantId].qty <= 0) {

        delete state[variantId];

        card.classList.remove('is-selected');

      } else {

        card.querySelector('[data-qty]')
          .textContent =
          state[variantId].qty;

      }

      updateSummary();

    }

  });

  /* CLEAR */

  modal
    .querySelector('[data-clear-pack]')
    ?.addEventListener('click', () => {

      Object.keys(state).forEach(key => {
        delete state[key];
      });

      modal
        .querySelectorAll('[data-product-card]')
        .forEach(card => {

          card.classList.remove('is-selected');

          const qty =
            card.querySelector('[data-qty]');

          if (qty) qty.textContent = 1;

        });

      updateSummary();

    });

  submitBtn.addEventListener('click', async () => {

    const items =
      buildCartItems();

    if (!items.length) return;

    submitBtn.disabled = true;

    submitBtn.classList.add(
      'is-disabled',
      'is-loading'
    );

    const submitText =
      submitBtn.querySelector(
        '.digi-packs-modal__cta-text'
      );

    if (submitText) {
      submitText.textContent =
        'ADICIONANDO...';
    }

    try {

      openCartDrawer();

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items
        })
      });

      closeModal();

      if (
        typeof Shopify !== 'undefined' &&
        Shopify.getCart
      ) {

        Shopify.getCart((cart) => {

          if (
            typeof window.updateCart === 'function'
          ) {

            window.updateCart(cart);

          }

          submitBtn.disabled = false;

          submitBtn.classList.remove(
            'is-disabled',
            'is-loading'
          );

          if (submitText) {

            submitText.textContent =
              'ADICIONAR AO CARRINHO';

          }

        });

      }

      } catch (error) {

        console.error(
          'Erro ao adicionar pack:',
          error
        );

        submitBtn.disabled = false;

        submitBtn.classList.remove(
          'is-disabled',
          'is-loading'
        );

        if (submitText) {

          submitText.textContent =
            'ADICIONAR AO CARRINHO';

        }

      }

  });

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  updateSummary();

})(); 